import React from "react";
import { Card } from "collections/Cards";
import { PolyIcon } from "elements";

interface InsightDetailsCardHeaderProps {
  className?: string;
  subHeader?: string;
  icon?: string;
}

export const InsightDetailsCard: React.FC<{ className?: string }> = ({
  children,
  className = ""
}) => {
  const classes = ["insight-details-card", className]
    .filter(c => !!c)
    .join(" ");
  return <Card className={classes}>{children}</Card>;
};

export const InsightDetailsCardHeader: React.FC<InsightDetailsCardHeaderProps> = ({
  children,
  subHeader,
  icon
}) => {
  return (
    <>
      <div
        data-testid={children}
        className={subHeader ? "card-header with-sub-header" : "card-header"}
      >
        {children}
        {icon && <PolyIcon icon={icon} className="insights-card-header-icon" />}
      </div>
      <p data-testid={subHeader} className="card-sub-header">
        {subHeader}
      </p>
    </>
  );
};
